import React, { useState } from 'react'
import {
    Card,
    CardBody,
    TabContent,
    TabPane,
    Nav,
    NavItem,
    NavLink
} from 'reactstrap'
import { BarChart, PieChart, AlertOctagon } from 'react-feather'
import classnames from 'classnames'

import NowTab from '@screens/EquipmentDetail/components/NowTab'
import HistoricalTab from '@screens/EquipmentDetail/components/HistoricalTab'
import AlertTab from '@screens/EquipmentDetail/components/AlertTab'
import { getRoleName } from '@common/utils'

import '@assets/scss/plugins/forms/flatpickr/flatpickr.scss'
import 'flatpickr/dist/themes/light.css'

const NOW_TAB_MODE = 1
const HISTORICAL_TAB_MODE = 2
const ALERT_TAB_MODE = 3

export default (props) => {
    const [viewDataActiveTab, setViewDataActiveTab] = useState(NOW_TAB_MODE)
    const isTechnicianRole = getRoleName() === 'TECHNICIAN'

    const viewDataTabMenu = [
        {
            title: 'NowTab',
            icon: <BarChart />,
            disabled: false,
            content: <NowTab
                {...props}
            />,
        },
        {
            title: 'HistoricalTab',
            icon: <PieChart />,
            disabled: isTechnicianRole,
            content: <HistoricalTab
                {...props}
            />,
        },
        {
            title: 'AlertTab',
            icon: <AlertOctagon />,
            disabled: isTechnicianRole,
            content: <AlertTab
                {...props}
            />
        }
    ]

    const viewDataTabsContent = []

    const renderViewDataMenu = () => {
        const toggleTabHandler = (tab) => {
            viewDataActiveTab !== tab ? setViewDataActiveTab(tab) : setViewDataActiveTab(viewDataActiveTab)
        }

        return viewDataTabMenu.map((viewDataTabMenu, index) => {
            const tabNumber = index + 1
            initializeViewDataTabsContent(tabNumber, viewDataTabMenu.content)

            return (
                <div key={viewDataTabMenu.title}>
                    <NavItem>
                        <NavLink
                            className={classnames({
                                active: viewDataActiveTab === tabNumber,
                            })}
                            disabled={viewDataTabMenu.disabled}
                            onClick={() => {
                                toggleTabHandler(tabNumber)
                            }}>
                            {viewDataTabMenu.icon}
                        </NavLink>
                    </NavItem>
                </div>
            )
        })
    }

    const initializeViewDataTabsContent = (tabNumber, tabContent) => {
        viewDataTabsContent.push(
            <TabPane key={tabNumber} tabId={tabNumber}>
                {tabContent || ''}
            </TabPane>
        )
    }

    return (
        <Card className='temp-container mt-1'>
            <CardBody className='p-0'>
                <div className='text-right mt-1'>
                    <Nav tabs className='justify-content-end mb-0 px-1'>
                        {renderViewDataMenu()}
                    </Nav>
                </div>
                <div className="px-1">
                    <TabContent activeTab={viewDataActiveTab}>
                        {viewDataTabsContent.map((viewDataTabsContent) => viewDataTabsContent)}
                    </TabContent>
                </div>
            </CardBody>
        </Card>
    )
}
